import { Linkedin, Mail, ArrowUp, Share2 } from "lucide-react";
import { Link } from "react-router-dom";
import { profil } from "../../data/content";
import { scrollToId } from "./Nav";

export const Footer = () => (
  <footer className="relative border-t border-white/5 py-14">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
        <div>
          <img
            src="/andrew.png"
            alt="Andrew Picornell"
            className="h-12 w-12 rounded-full object-cover object-top border border-white/15"
          />
          <p className="font-display text-2xl md:text-3xl mt-6 max-w-md leading-tight">
            Faire le lien entre <span className="font-serif-italic text-cyan">management</span>, métiers & IA.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <a href={`mailto:${profil.email}`} className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-cyan hover:border-cyan/50 transition-colors duration-300" aria-label="E-mail" data-testid="footer-email">
            <Mail size={18} />
          </a>
          <a href={profil.linkedin} target="_blank" rel="noopener noreferrer" className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-cyan hover:border-cyan/50 transition-colors duration-300" aria-label="LinkedIn" data-testid="footer-linkedin">
            <Linkedin size={18} />
          </a>
          <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(profil.siteUrl)}`} target="_blank" rel="noopener noreferrer" className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-cyan hover:border-cyan/50 transition-colors duration-300" aria-label="Partager sur LinkedIn" data-testid="footer-share">
            <Share2 size={18} />
          </a>
          <button onClick={() => scrollToId("accueil")} className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-cyan hover:border-cyan/50 transition-colors duration-300" aria-label="Haut de page" data-testid="footer-top">
            <ArrowUp size={18} />
          </button>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[var(--muted)]">
        <span>© {new Date().getFullYear()} {profil.prenomNom}. Tous droits réservés.</span>
        <div className="flex items-center gap-5">
          <Link to="/admin" className="hover:text-cyan transition-colors" data-testid="footer-admin-link">Espace privé</Link>
          <span>{profil.localisation}</span>
        </div>
      </div>
    </div>
  </footer>
);
